import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Divider } from 'primereact/divider';
import { Button } from 'primereact/button';
import { isMobile } from "react-device-detect";

const UpdateSuccess = () => {

  const [isAndroid,setIsAndroid] = React.useState(false)
  const [fromMobile,setFromMobile] = React.useState(false)
  const history = useHistory()
  const getCookieValue = (name)=>{
      const regex = new RegExp(`(^| )${name}=([^;]+)`)
      const match = document.cookie.match(regex)
      if (match) {
        return match[2]
      }
   }
  useEffect(() => {
    try{
    const userAgent = navigator.userAgent.toLowerCase();
    const android = /android/g.test(userAgent);
     setFromMobile(false)
     var applicationName = JSON.stringify(getCookieValue("applicationNameFlag"))

      if(applicationName.toLowerCase().indexOf("reactnative") >-1 ||applicationName.toLowerCase().indexOf("mobile") >-1){
        setFromMobile(true)
      }

      var date = new Date();
      date.setTime(date.getTime() + (3 * 24 * 60 * 60 * 1000));
      var expires = "; expires=" + date.toGMTString();
      document.cookie = "applicationNameFlag" + "=" + ";"+ expires + "; path=/; domain=" + ".fdnycloud.org";
    if(android){
      setIsAndroid(true)
    }else{
      setIsAndroid(false)
    }

    }catch(err){
      console.log(err)
    }
  }, []);

  return (
    <>
    
    <div className="rightside-container">
      <div className="rightside-body px-6">
        <div className='flex flex-column align-items-center'>
          <h3>{history.location.state.title||''}</h3>
          <span>{history.location.state.message||''}</span>
          <Divider className='py-3' />
        </div>
        <div className="pt-2 lg:w-5 md:w-5 mx-auto">
          <div style={{ width: '150px', height: '150px'}} className="bg-green-500 border-circle flex justify-content-center align-items-center mx-auto">
            <i className="pi pi-check text-white" style={{ 'fontSize': '3em' }}></i>
          </div>
          <h2 className='text-center'>Success!</h2>
        {fromMobile ? 
        
        <div style={{textAlign:'center'}}><h3>Close page to go back to login.</h3></div>
        
        
        :<Button label={history.location.state.redirecturl? "Back" : "Back to home" } onClick={()=>{
          if(history.location.state.redirecturl){
            window.location.href = history.location.state.redirecturl
          }else{
            window.location.href = "/accountmanagement/auth/my-profile"
            //history.push({pathname:"/auth/my-profile"})
          }
        }} className="mt-5 p-button-outlined p-button-info w-full py-3" />}



        </div>
      </div>
    </div>
    
   
    </>
  );
}

export default UpdateSuccess;
